import { createMarketplaceHttpClient } from "../marketplaceHttpClient";

const api = createMarketplaceHttpClient();

export default api;
